jQuery(document).ready(function () {
	if (isOnScreen(jQuery('.wp-block-counter'))) {
		statistikCounter();
	} else {
		jQuery(window).scroll(function () {
			let fired = 0;

			if (isOnScreen(jQuery('.wp-block-counter')) && fired === 0) {
				statistikCounter();
				fired = 1;
			}
		});
	}
});

function statistikCounter() {
	jQuery('.wp-block-counter span.counter_number').each(function () {
		const duration = jQuery(this).data('duration');
		jQuery(this)
			.prop('Counter', 0)
			.animate(
				{
					Counter: jQuery(this).data('value'),
				},
				{
					duration,
					easing: 'swing',
					step(now) {
						jQuery(this).text(Math.ceil(now));
					},
				}
			);
	});
}

function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if (elem.length === 0) {
		return;
	}
	const $window = jQuery(window);
	const viewportTop = $window.scrollTop();
	const viewportHeight = $window.height();
	const viewportBottom = viewportTop + viewportHeight;
	const $elem = jQuery(elem);
	const top = $elem.offset().top;
	const height = $elem.height();
	const bottom = top + height;

	return (
		(top >= viewportTop && top < viewportBottom) ||
		(bottom > viewportTop && bottom <= viewportBottom) ||
		(height > viewportHeight && top <= viewportTop && bottom >= viewportBottom)
	);
}
